"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const useMergeRefs_1 = __importDefault(require("../../hooks/useMergeRefs"));
const Button_1 = __importDefault(require("../Button/Button"));
const Icon_1 = __importDefault(require("../Icon/Icon"));
const CloseSmall_1 = __importDefault(require("../Icon/Icons/components/CloseSmall"));
const BannerConstants_1 = require("./BannerConstants");
require("./Banner.scss");
/**
 * Default `renderTitle` and `renderSubtitle` function
 */
const PRESERVE_VALUE = (value) => value;
const Banner = (0, react_1.forwardRef)(({ className = "", imageAlt = "", imageSrc = "", imagePosition = BannerConstants_1.IMAGE_POSITIONS.LEFT, imageClassName = "", renderTitle = PRESERVE_VALUE, renderSubtitle = PRESERVE_VALUE, title = "", subtitle = "", onClose = null, rtl = false, ariaLabel = "Banner" }, ref) => {
    const componentRef = (0, react_1.useRef)(null);
    const mergedRef = (0, useMergeRefs_1.default)({ refs: [ref, componentRef] });
    const renderedTitle = (0, react_1.useMemo)(() => {
        const computedTitle = renderTitle(title);
        if (!computedTitle)
            return null;
        return (0, jsx_runtime_1.jsx)("h2", Object.assign({ className: "banner--title" }, { children: computedTitle }));
    }, [title, renderTitle]);
    const renderedSubtitle = (0, react_1.useMemo)(() => {
        const computedSubtitle = renderSubtitle(subtitle);
        if (!computedSubtitle)
            return null;
        return (0, jsx_runtime_1.jsx)("h3", Object.assign({ className: "banner--subtitle" }, { children: computedSubtitle }));
    }, [subtitle, renderSubtitle]);
    const renderImage = (0, react_1.useMemo)(() => {
        if (!imageSrc)
            return null;
        return (0, jsx_runtime_1.jsx)("img", { src: imageSrc, alt: imageAlt, className: (0, classnames_1.default)("banner--image", imageClassName) });
    }, [imageAlt, imageSrc, imageClassName]);
    const renderCloseButton = (0, react_1.useMemo)(() => {
        if (!onClose)
            return null;
        return ((0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ onClick: onClose, className: "banner--close", size: Button_1.default.sizes.SMALL, kind: Button_1.default.kinds.TERTIARY, color: Button_1.default.colors.PRIMARY, ariaLabel: "Close" }, { children: (0, jsx_runtime_1.jsx)(Icon_1.default, { iconType: Icon_1.default.type.SVG, clickable: false, icon: CloseSmall_1.default, iconSize: "16px", ignoreFocusStyle: true }) })));
    }, [onClose]);
    return ((0, jsx_runtime_1.jsx)("aside", Object.assign({ ref: mergedRef, className: (0, classnames_1.default)(className, "banner", { rtl }), "aria-label": ariaLabel }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: (0, classnames_1.default)("banner--content", `image-position__${imagePosition}`, {
                "close-button-spacing": !!renderCloseButton
            }) }, { children: [renderCloseButton, renderedTitle, renderedSubtitle, renderImage] })) })));
});
Banner.imagePosition = BannerConstants_1.IMAGE_POSITIONS;
exports.default = Banner;
